import React from 'react';
import { OfferBox } from '../ui/OfferBox';
import { finalIncludes } from '../../data/offer';
export function FinalCTA() {
  return <section className="w-full bg-ink px-4 py-16 md:py-24" data-id="element-158" data-mp="5cqyshfbi5as">
      <div className="mx-auto max-w-3xl text-center" data-id="element-159" data-mp="3mua6c0zmcdp3">
        <p className="font-display text-sm font-extrabold uppercase tracking-wide text-cyan md:text-base" data-id="element-160" data-mp="3mrnzk3kjy27x">
          Ready to organize your hair restoration references?
        </p>
        <h2 className="mt-3 text-balance font-display text-[32px] font-black leading-[1.05] tracking-tight text-white md:text-5xl" data-id="element-161" data-mp="3dris5tfcz3tr">
          Bring Your Hair Transplant Educational Resources Together in One Place.
        </h2>
        <div className="mt-5 space-y-3 text-[17px] leading-relaxed text-white/75 md:text-lg" data-id="element-162" data-mp="33x8x23z17rfc">
          <p data-id="element-163" data-mp="38w3hfacndo1k">You’ve invested time in developing your professional knowledge.</p>
          <p data-id="element-164" data-mp="124cdttuyxik5">
            Now you can organize related educational references, anatomical study materials, assessment frameworks, case
            studies, and documentation resources within a single collection.
          </p>
        </div>
      </div>
      <div className="mt-10" data-id="element-165" data-mp="la280px1esbl">
        <OfferBox ribbon="Get the complete collection for just $27 USD" includesTitle="Your complete Hair Transplant Blueprint™ includes" includes={finalIncludes} ctaLabel="Get Hair Transplant Blueprint™ now" ctaSub="Digital product · One-time payment · No recurring subscription" data-id="element-166" data-mp="l8r32mruveiw" />
      </div>
    </section>;
}